import { EMAIL_GROUPS } from "../../utilities/emailGroups";

export const stockColor = (count) => {
  if (count === 0) return "text-red-500";
  if (count <= 5) return "text-yellow-500";
  return "text-green-500";
};

export const StockBadge = (count) => {
  const n = Number(count);
  if (n === 0) return { color: "failure", label: "Out of stock" };
  if (n <= 5) return { color: "warning", label: "Low stock" };
  return { color: "success", label: "In stock" };
};

export const DEFAULT_APPROVERS = [
  "cathyj@gomarkets.com",
  "daniellaw@gomarkets.com",
];

export const DEFAULT_APPROVERS_SYD = ["yoriy@gomarkets.com"];

export const getApproversForRequester = (requesterEmail) => {
  const group = EMAIL_GROUPS.find((r) => r.requesters.includes(requesterEmail));
  return group ? group.approvers : DEFAULT_APPROVERS;
};

export const buildEmailTemplateHtml = ({
  title,
  requesterName,
  itemName,
  itemCount,
  purpose,
  status,
  note,
  declineReason,
  requestUrl,
}) => {
  return `
  <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 24px; background-color: #f9fafb;">
    <div style="background-color: #ffffff; border-radius: 12px; padding: 32px; margin-bottom: 16px; border: 1px solid #e5e7eb;">

      <div style="margin-bottom: 24px;">
        <h1 style="margin: 0; font-size: 18px; font-weight: 700; color: #111827;">GOM Merchandise</h1>
        <p style="margin: 0; font-size: 12px; color: #6b7280;">Merchandise Management System</p>
      </div>

      <hr style="border: none; border-top: 1px solid #e5e7eb; margin-bottom: 24px;" />

      <h2 style="margin: 0 0 24px; font-size: 22px; font-weight: 700; color: #111827;">${title}</h2>

      <div style="border: 1px solid #e5e7eb; border-radius: 10px; overflow: hidden; margin-bottom: 20px;">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background-color: #f9fafb; border-bottom: 1px solid #e5e7eb;">
          <span style="font-size: 13px; color: #6b7280;">Requested by</span>
          <span style="font-size: 13px; font-weight: 600; color: #111827;">${requesterName}</span>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background-color: #ffffff; border-bottom: 1px solid #e5e7eb;">
          <span style="font-size: 13px; color: #6b7280;">Item</span>
          <span style="font-size: 13px; font-weight: 600; color: #111827;">${itemName}</span>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background-color: #f9fafb; border-bottom: 1px solid #e5e7eb;">
          <span style="font-size: 13px; color: #6b7280;">Quantity</span>
          <span style="font-size: 13px; font-weight: 600; color: #111827;">${itemCount}</span>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background-color: #ffffff; border-bottom: 1px solid #e5e7eb;">
          <span style="font-size: 13px; color: #6b7280;">Purpose</span>
          <span style="font-size: 13px; font-weight: 600; color: #111827;">${purpose}</span>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background-color: #f9fafb;">
          <span style="font-size: 13px; color: #6b7280;">Status</span>
          <span style="font-size: 13px; font-weight: 600; padding: 2px 10px; border-radius: 999px; background-color: #fef9c3; color: #854d0e;">${status}</span>
        </div>
      </div>

      ${
        note
          ? `<div style="background-color: #f0fdf4; border-radius: 8px; padding: 14px 16px; margin-bottom: 16px; border-left: 4px solid #22c55e;">
        <p style="font-size: 13px; color: #166534; margin: 0;"><strong>Note:</strong> ${note}</p>
      </div>`
          : ""
      }

      ${
        declineReason
          ? `<div style="background-color: #fef2f2; border-radius: 8px; padding: 14px 16px; border-left: 4px solid #ef4444;">
        <p style="font-size: 13px; color: #991b1b; margin: 0;"><strong>Decline reason:</strong> ${declineReason}</p>
      </div>`
          : ""
      }

      <div style="text-align: center; margin-top: 8px;">
        <a href="${requestUrl}" target="_blank" style="display: inline-block; background-color: #111827; color: #ffffff; font-size: 14px; font-weight: 600; padding: 12px 28px; border-radius: 8px; text-decoration: none;">
          View request
        </a>
      </div>

    </div>
  </div>

  <div style="text-align: center; padding: 8px 16px;">
    <p style="font-size: 12px; color: #9ca3af; margin: 0;">
      This is an automated message from <a href="https://gom.digital/" target="_blank">GOM</a>. Please do not reply to this email.
    </p>
  </div>
  `;
};
